import { render, staticRenderFns } from "./manual-invoice.component.vue?vue&type=template&id=5b84875e&scoped=true&"
import script from "./manual-invoice.component.vue?vue&type=script&lang=js&"
export * from "./manual-invoice.component.vue?vue&type=script&lang=js&"
import style0 from "./manual-invoice.component.vue?vue&type=style&index=0&id=5b84875e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b84875e",
  null
  
)

export default component.exports